import FilledFloatingLabelInputMixin from '../mixins/filled-floating-label-input-mixin.js';
import TpSelectFilledMixin from './tp-select-filled-mixin.js';
import TpSelectBase from './tp-select-base.js';

class TpSelectFilled extends 
  TpSelectFilledMixin(
  FilledFloatingLabelInputMixin(
    TpSelectBase
  )) {}

export default TpSelectFilled;
